import { useState, useRef, useEffect } from "react";
import { Form } from "react-bootstrap";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const SelectField = ({
  formik,
  formClass = null,
  label,
  valueName,
  value,
  style = null,
  children,
  onChange,
}) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  // Parse <option> children into [{value, label}]
  const options = React.Children.toArray(children)
    .filter((c) => c.type === "option")
    .map((c) => ({ value: c.props.value ?? "", label: c.props.children ?? c.props.value ?? "" }));

  const currentValue = value !== undefined ? value : (formik ? formik.values?.[valueName] : undefined);
  const selected = options.find((o) => String(o.value) === String(currentValue ?? ""));

  const handleSelect = (optValue) => {
    if (onChange) {
      onChange({ target: { value: optValue } });
    } else if (formik) {
      formik.setFieldValue(valueName, optValue);
    }
    setOpen(false);
  };

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const isInvalid = formik && !!formik.errors[valueName];

  return (
    <div
      className={formClass ? formClass : "form-field-group"}
      style={style}
      ref={containerRef}
    >
      {label && (
        <Form.Label style={{ fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6, display: "block" }}>
          {label}
        </Form.Label>
      )}

      <div style={{ position: "relative" }}>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          style={{
            width: "100%", minHeight: 48, padding: "13px 40px 13px 14px",
            border: `1.5px solid ${isInvalid ? "#f34e4e" : open ? "#038edc" : "#e2e5ea"}`,
            borderRadius: 10, background: "#fff", textAlign: "left",
            fontSize: 14, color: selected?.label ? "#111827" : "#adb5bd",
            cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between",
            boxShadow: open ? "0 0 0 3px rgba(3,142,220,0.12)" : "none",
            transition: "border-color 0.18s ease, box-shadow 0.18s ease",
          }}
        >
          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {selected?.label || <span style={{ color: "#adb5bd" }}>Select…</span>}
          </span>
          <FontAwesomeIcon
            icon={faChevronDown}
            style={{
              fontSize: 11, color: "#9299a8", flexShrink: 0, marginLeft: 8,
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.18s ease",
            }}
          />
        </button>

        {open && (
          <div style={{
            position: "absolute", zIndex: 1050, top: "calc(100% + 6px)", left: 0, right: 0,
            background: "#fff", borderRadius: 12,
            boxShadow: "0 8px 32px rgba(0,0,0,0.13), 0 1px 4px rgba(0,0,0,0.06)",
            border: "1px solid #eaecf0",
            maxHeight: 260, overflowY: "auto", padding: "6px",
          }}>
            {options.map((opt) => {
              const isSelected = String(opt.value) === String(currentValue ?? "");
              return (
                <div
                  key={opt.value}
                  onMouseDown={() => handleSelect(opt.value)}
                  style={{
                    padding: "11px 14px", borderRadius: 8, fontSize: 14, cursor: "pointer",
                    color: isSelected ? "#038edc" : "#111827",
                    background: isSelected ? "rgba(3,142,220,0.07)" : "transparent",
                    fontWeight: isSelected ? 600 : 400,
                    transition: "background 0.12s ease",
                  }}
                  onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.background = "rgba(3,142,220,0.05)"; }}
                  onMouseLeave={(e) => { if (!isSelected) e.currentTarget.style.background = "transparent"; }}
                >
                  {opt.label}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {isInvalid && (
        <div style={{ fontSize: 12, fontWeight: 500, color: "#f34e4e", marginTop: 5 }}>
          {formik.errors[valueName]}
        </div>
      )}
    </div>
  );
};

export default SelectField;
